const fadeInText = (selector, options = {}) => {
  const defaultOptions = {
    root: null,
    threshold: 0.1,
    rootMargin: '0px 0px -20px 0px'
  }

  const observerOptions = { ...defaultOptions, ...options }

  const observer = new IntersectionObserver((entries, observ) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('fade-in')
        observ.unobserve(entry.target)
      }
    })
  }, observerOptions)

  const elements = document.querySelectorAll(selector)
  elements.forEach((element) => observer.observe(element))
}

export default fadeInText
